import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreGridRow } from "@slhuicore/grid-row";
import { style } from "./assets/row.generated-style";

/**
 * Wrapper component for <slh-col>, which utilizes flex properties to control the layout and flow of its inner columns.
 */
@customElement("slh-row")
export default class SlhRow extends SlhCoreGridRow(LitElement) {
  static styles = style;
}
